import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import PropTypes from 'prop-types';
import React from 'react';
import { FieldsProvider as FieldsProvider$1, ComponentsProvider, FIELDS_NAMESPACE } from '@panneau/core/contexts';
import fieldAutocomplete, { definition } from '@panneau/field-autocomplete';
import fieldCheckboxes, { definition as definition$1 } from '@panneau/field-checkboxes';
import fieldColor, { definition as definition$2 } from '@panneau/field-color';
import { Date, DateTime, Time, definition as definition$3 } from '@panneau/field-date';
import fieldDisplay, { definition as definition$4 } from '@panneau/field-display';
import fieldEmbed, { definition as definition$5 } from '@panneau/field-embed';
import fieldFields, { definition as definition$6 } from '@panneau/field-fields';
import fieldHtml, { definition as definition$7 } from '@panneau/field-html';
import fieldInputGroup, { definition as definition$9 } from '@panneau/field-input-group';
import fieldItem, { definition as definition$a } from '@panneau/field-item';
import fieldImport, { definition as definition$8 } from '@panneau/field-import';
import fieldItems, { definition as definition$b } from '@panneau/field-items';
import fieldLocalized, { definition as definition$c } from '@panneau/field-localized';
import fieldNumber, { definition as definition$d } from '@panneau/field-number';
import fieldRadios, { definition as definition$e } from '@panneau/field-radios';
import fieldSelect, { definition as definition$g } from '@panneau/field-select';
import fieldText, { Email, Password, Telephone, Textarea, definition as definition$h } from '@panneau/field-text';
import fieldToggle, { definition as definition$i } from '@panneau/field-toggle';
import fieldToggles, { definition as definition$j } from '@panneau/field-toggles';
import fieldUpload, { AudioField, DocumentField, FontField, ImageField, ImagesField, VideoField, definition as definition$k } from '@panneau/field-upload';
import fieldUrl, { definition as definition$l } from '@panneau/field-url';
import fieldResourceItem, { definition as definition$f } from '@panneau/field-resource-item';
import isArray from 'lodash-es/isArray';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Audio: AudioField,
    Autocomplete: fieldAutocomplete,
    Checkboxes: fieldCheckboxes,
    Color: fieldColor,
    Date: Date,
    DateTime: DateTime,
    Display: fieldDisplay,
    Document: DocumentField,
    Email: Email,
    Embed: fieldEmbed,
    Fields: fieldFields,
    Font: FontField,
    Html: fieldHtml,
    Image: ImageField,
    Images: ImagesField,
    Import: fieldImport,
    InputGroup: fieldInputGroup,
    Item: fieldItem,
    Items: fieldItems,
    Localized: fieldLocalized,
    Number: fieldNumber,
    Password: Password,
    Radios: fieldRadios,
    ResourceItem: fieldResourceItem,
    Select: fieldSelect,
    Telephone: Telephone,
    Text: fieldText,
    Textarea: Textarea,
    Time: Time,
    Toggle: fieldToggle,
    Toggles: fieldToggles,
    Upload: fieldUpload,
    Url: fieldUrl,
    Video: VideoField
});

var definitions = [definition, definition$1, definition$2, definition$3, definition$4, definition$5, definition$6, definition$7, definition$8, definition$9, definition$a, definition$b, definition$c, definition$d, definition$e, definition$f, definition$g, definition$h, definition$i, definition$j, definition$k, definition$l].reduce(function (allFields, definition) {
  return [].concat(_toConsumableArray(allFields), _toConsumableArray(isArray(definition) ? definition : [definition]));
}, []);

var propTypes = {
  definitions: PropTypes.array,
  // eslint-disable-line
  components: PropTypes.object,
  // eslint-disable-line
  children: PropTypes.node.isRequired
};
var defaultProps = {
  definitions: [],
  components: {}
};
var FieldsProvider = function FieldsProvider(_ref) {
  var injectedDefinitions = _ref.definitions,
    injectedComponents = _ref.components,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(FieldsProvider$1, {
    fields: [].concat(_toConsumableArray(definitions), _toConsumableArray(injectedDefinitions))
  }, /*#__PURE__*/React.createElement(ComponentsProvider, {
    namespace: FIELDS_NAMESPACE,
    components: _objectSpread(_objectSpread({}, components), injectedComponents)
  }, children));
};
FieldsProvider.propTypes = propTypes;
FieldsProvider.defaultProps = defaultProps;

export { FieldsProvider as default };
